import { useHistory, useLocation } from 'react-router-dom';
import { HomeIcon, EllipsisHorizontalIcon } from '@heroicons/react/24/solid';
import { ContactObjectIcon, FormObjectIcon, PaymentObjectIcon } from '../../../components/icons/DashboardObjectIcons';
import { checkPermission } from '../../utils/auth';
import { P } from '../../utils/permissions';

export const MOBILE_DESTINATIONS = [
  { label: 'Home', path: '/' },
  { label: 'Payments', path: '/payments', permission: P.VIEW_PAYMENTS },
  { label: 'Contacts', path: '/contacts', permission: P.VIEW_CONTACTS },
  { label: 'Forms', path: '/forms', permission: P.VIEW_FORMS },
];

const icons = { Home: HomeIcon, Payments: PaymentObjectIcon, Contacts: ContactObjectIcon, Forms: FormObjectIcon };

export default function MobileDashboardNavigation({ sidebarOpen, onToggleSidebar, onCloseSidebar, dismissSurfaces }) {
  const history = useHistory();
  const { pathname } = useLocation();
  const primaryActive = MOBILE_DESTINATIONS.some(item => item.path === '/' ? pathname === '/' : pathname === item.path || pathname.startsWith(`${item.path}/`));
  const itemClass = active => `flex min-h-12 min-w-0 flex-1 flex-col items-center justify-center gap-0.5 rounded-full text-[10px] min-[360px]:text-[11px] font-medium transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-sage ${active ? 'bg-paper-inset text-ink' : 'text-ink-secondary hover:bg-paper-muted'} disabled:opacity-40`;
  return <nav aria-label="Main navigation" className="flex min-w-0 flex-1 items-center rounded-full border border-edge bg-paper-light p-1 shadow-sm">
    {MOBILE_DESTINATIONS.map(item => {
      const Icon = icons[item.label];
      const allowed = !item.permission || checkPermission(item.permission);
      const active = !sidebarOpen && (item.path === '/' ? pathname === '/' : pathname === item.path || pathname.startsWith(`${item.path}/`));
      return <button key={item.path} type="button" aria-label={item.label} aria-current={active ? 'page' : undefined} disabled={!allowed} title={!allowed ? `You don't have permission to view ${item.label.toLowerCase()}` : undefined} className={itemClass(active)} onClick={() => {
        if (item.permission && !checkPermission(item.permission)) return;
        dismissSurfaces();
        onCloseSidebar?.();
        if (pathname !== item.path) history.push(item.path);
      }}><Icon className="h-5 w-5" aria-hidden="true" /><span>{item.label}</span></button>;
    })}
    <button type="button" data-sidebar-trigger data-mobile-more aria-label="More" aria-current={sidebarOpen || !primaryActive ? 'page' : undefined} aria-expanded={!!sidebarOpen} aria-controls="sidebar" className={itemClass(sidebarOpen || !primaryActive)} onClick={() => { dismissSurfaces(); if (!sidebarOpen) onToggleSidebar?.(); }}><EllipsisHorizontalIcon className="h-5 w-5" aria-hidden="true" /><span>More</span></button>
  </nav>;
}
